import { render } from "./CorrectForeView.vue?vue&type=template&id=47536c6a&scoped=true&ts=true"
import script from "./CorrectForeView.vue?vue&type=script&lang=ts"
export * from "./CorrectForeView.vue?vue&type=script&lang=ts"

import "./CorrectForeView.vue?vue&type=style&index=0&id=47536c6a&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47536c6a"]])

export default __exports__